export enum TaskStatus {
    Scheduled = 'scheduled',
    Started = 'started',
    Finished = 'finished',
    FinishedWithErrors = 'finished-with-errors',
    Error = 'error',
}

export class TaskResult {
    status: TaskStatus;
    result: any;

    constructor(status, result) {
        this.status = status;
        this.result = result;
    }
}